import { render, staticRenderFns } from "./CustomLoginModals.vue?vue&type=template&id=d4d8f9fa"
import script from "./CustomLoginModals.vue?vue&type=script&lang=js"
export * from "./CustomLoginModals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports